import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {SavedMealsDependencies} from '../dependencies';
import {RECENT_LINE_INGREDIENTS_STALE_TIME_MS} from './constants';
import {keys} from './keys';

export type ListRecentLineIngredientsQueryDependencies = Pick<
  SavedMealsDependencies,
  'controllers'
>;

export const listRecentLineIngredientsQuery = (
  {controllers}: ListRecentLineIngredientsQueryDependencies,
  limit: number,
) =>
  queryOptions({
    queryKey: keys.recentItems(limit),
    queryFn: () => controllers.savedMealController.listRecentLineIngredients({limit}).then(unwrap),
    staleTime: RECENT_LINE_INGREDIENTS_STALE_TIME_MS,
  });
